﻿

(() => {
    angular.module('fliptoWeb')
        .animation('.modal-animate', [() => {
        return {
            enter(element, done) {
                var tl = new TimelineLite({ onComplete: done });
                tl.from(element, .5, { opacity: 0, ease: Power2.easeOut })
                    .from(".modal-dialog", .5, { opacity: 0, y: "+=50px", ease: Power2.easeOut }, "-=.5");

                return cancelled => {
                    //this (optional) function will be called when the animation
                    //completes or when the animation is cancelled (the cancelled
                    //flag will be set to true if cancelled).
                }
            },
            leave(element, done) {
                var tl = new TimelineLite({ onComplete: done });
                tl.to(element, 0, { opacity: 0, display: "none", ease: Power2.easeOut });

                return cancelled => {
                    //this (optional) function will be called when the animation
                    //completes or when the animation is cancelled (the cancelled
                    //flag will be set to true if cancelled).
                }
            }
        }
    }]);
})()
